export default ({ data }, { t }) => {
  if (!data) {
    return {};
  }

  const { search } = data;

  if (!search) {
    return {};
  }
  const meta = {
    query: search.query,
  };

  return {
    noIndex: true,
    description: t('meta', 'search.description', meta),
    title: t('meta', 'search.title', meta),
  };
};
